import styled from 'styled-components';

export const PrescricaoMedicaHeading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
